@for (span of data(); track span.hexCode) {
  <div class="span-wrapper">
    <div class="color-wrapper">
      <div class="color-sample" [style.background-color]="span.hexCode"></div>
      <gc-text [variant]="'information'" [textColor]="'secondary'">
        {{ span.colorName | translate }}
      </gc-text>
    </div>
    <gc-text [variant]="'information'">{{
      span.description | translate
    }}</gc-text>
  </div>
}
